import React from 'react';

export const SearchContext = React.createContext({ term: '' });
export const useSearchContext = () => React.useContext(SearchContext);
